<template>
  <div class="main-maintenance">
    <div class="main-maintenance-image">
      <img ref="maintenance-image" src="../../static/series/cutbed/图片11.png" alt="">
    </div>
    <div class="main-maintenance-text">
      <div class="main-maintenance-text1">
        {{ $t('series.maintenance_text1') }}
      </div>
      <div v-if="this.$i18n.locale === 'zh'" class="main-maintenance-text2">
        太势裁床使用手册中，根据使用时间，<br>
        有<span class="main-maintenance-span">详细的保养流程和保养指导。</span><br>
        使用配套的保养套装零件和工具包，<br>
        你也能轻轻松松完成维护保养，<br>
        让你的裁床时刻保持巅峰状态。
      </div>
      <div v-else class="main-maintenance-text2">
        Our step-by-step guide makes it easy.<br>
        With our <span class="main-maintenance-span">matched parts set and clear instructions,</span><br>
        keeping your cutter in peak condition<br>
        has never been easier.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "maintenance",
  data() {
    return {}
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(this.$refs['maintenance-image'], {
        scale: 3
      })

      this.$gsap.set(['.main-maintenance-text1', '.main-maintenance-text2'], {
        opacity: 0,
        y: 100
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.main-maintenance',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          once: true,
          // scrub: 1,
          toggleActions: 'play none none none'
        }
      })

      masterTimeline.to(this.$refs['maintenance-image'], {
        scale: 1,
        duration: 2,
      }, 0.5)

      masterTimeline.to('.main-maintenance-text1', {
        opacity: 1,
        color: '#333',
        y: 5,
        duration: 2,
      }, 0.5)

      masterTimeline.to('.main-maintenance-text1', {
        opacity: 1,
        y: -20,
        color: '#808080',
        duration: 2,
      }, 3)

      masterTimeline.to(this.$refs['maintenance-image'], {
        duration: 2,
        scale: 1.2
      }, 3)

      masterTimeline.to('.main-maintenance-text2', {
        opacity: 1,
        y: -15,
        scale: 1,
        duration: 2,
      }, 3)
    })
  }
}
</script>
<style scoped>
.main-maintenance {
  position: relative;
  width: 100%;
  margin-top: 500px;
}

.main-maintenance-image {
  width: 100%;


  img {
    width: 100%;
  }
}

.main-maintenance-text {
  position: absolute;
  top: 40%;
  left: 40%;
  text-align: left;
}

.main-maintenance-text1 {
  color: #808080;
  font-size: 2em;
  margin-bottom: 10px;
}


.main-maintenance-text2 {
  font-size: 1.5em;
}

.main-maintenance-span {
  color: #46b1e1;
}
</style>
